

import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { submitApproveRejectApplication, submitEnclosureFiles, submitPanelApproveRejectApplication } from "../../auth/services/privateapicalling";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import { toast,ToastContainer } from "react-toastify";
import CommonSelect, { Option } from "../license-registration-form/CommonSelect";
import { getAllAPMC } from "../../auth/services/apiCalling";


interface RectificationProp {
   docs:any[];
  rejectedDocs: any[];
  rejectedFields: Record<string, any>;
  applicationId: string;
  token: string;
  buttonData: any[];
  education:any[];
  applicationTransaction:any[];
}

const RectificationOnResjection: React.FC<RectificationProp> = ({docs, rejectedDocs , rejectedFields , applicationId , token ,buttonData , education , applicationTransaction})=> {


  const [formData, setFormData] = useState<{ [key: string]: string }>({});
  const [files, setFiles] = useState<{ [key: string]: File | null }>({});
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [uploading, setUploading] = useState<{ [key: string]: boolean }>({});
  const [comment , setComment] = useState<string>("");
  const [status , setStatus] = useState<string>("");
  const language = useSelector((state:any)=>state.auth.language);
  const formLanguage = useSelector((state:any)=>state.auth.formLanguage);

  const [appStatusLevel , setAppStatusLevel] = useState<string>("");
  const [experienceDetail , setExperienceDetail]= useState([]);
  const [validationErrors, setValidationErrors] = useState<{ [key: string]: string }>({});
  const [fileValidationErrors, setFileValidationErrors] = useState<{ [key: string]: string }>({});
  const [hasFormError, setHasFormError] = useState(false);
  const [hasFileError, setHasFileError] = useState(false);

  const [fileError , setFileError]= useState<{ [key: string]: string }>({});
    const [talukaOptionsPer , setTalukaOptionsPer] = useState<Option[]>([]);
    const [districtOptions , setDistrictOptions] = useState<Option[]>([]);
    const [talukaOptionsReg , setTalukaOptionsReg] = useState<Option[]>([]);
  const [uploadedDoc, setUploadedDoc] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [specialization, setSpecialization] = useState<{ standard: string; specialization: string }[]>([]);
  const [reviews , setReviews] = useState<any[]>([])


  

  const rejectedFieldsArray = Array.isArray(rejectedFields) ? rejectedFields : Object.keys(rejectedFields);

 
  const standard = education.find(data=>data.standard=="mastersDegree" || data.standard=="phd" )?.standard;

  let minexp = (standard =="mastersDegree" || standard=="phd" ) ? 4 : 5;


  

  const fieldsOptions =  [
    { value: "applicantName", label: "Applicant Name" },
    { value: "currAddress", label: "Current Address" },
    { value: "perAddress", label: "Permanent Address" },
    { value: "regOffAddress", label: "Registered Office Address" },
    { value: "panCardNo", label: "Pan Card Number" },
    { value: "electionCardNo", label: "Election Card Number" },
    { value: "regEmailId", label: "Registered Email ID" },
    { value: "mobileNo", label: "Mobile Number" },
    { value: "isFirm", label: "Is Firm" },
    { value: "entityName", label: "Entity Name" },
    { value: "entityType", label: "Entity Type" },
    { value: "entityRegistrationNo", label: "Entity Registration Number" },
    { value: "entityGstNo", label: "Entity GST Number" },
    { value: "entityPanNo", label: "Entity PAN Number" },
    { value: "entityFpoNo", label: "Entity FPO Number" },
    { value: "dob", label: "DOB" },
    { value: "itReturnDetail", label: "IT Returns for Last Three years" },
    { value: "declarationDetail", label: "Applicant Declaration" },
    { value: "highSchool", label: "High School" },
    { value: "diploma", label: "Diploma" },
    { value: "bachelorDegree", label: "Bachelor's Degree" },
    { value: "mastersDegree", label: "Master's Degree" },
   { value: "phd", label: "PHD" },
    { value: "yrOfExpAsBusErr", label: "Year of Experience as Business Engineer" }, 
    { value: "experienceDoc_1", label: "Experience Detail One" },
    { value: "experienceDoc_2", label: "Experience Detail Two" },
    { value: "experienceDoc_3", label: "Experience Detail Three" },
    { value: "workPerformanceDoc_1", label: "Work Performed Detail One" },
    { value: "workPerformanceDoc_2", label: "Work Performed Detail Two" },
    { value: "workPerformanceDoc_3", label: "Work Performed Detail Three" },
    { value: "constructionDocs_1", label: "Construction Done Details One" },
    { value: "constructionDocs_2", label: "Construction Done Details Two" },
    { value: "constructionDocs_3", label: "Construction Done Details Three" },
  ];

  const keyMapping = {
    itReturnDetail: "itReturns",
    declarationDetail: "declaration",
  }

  const navigate = useNavigate();

  const handleInputChange = (e,fieldKey?:any,key?:any) => {
    //.log('fileeeee eeevemttt',e.target.name)
    //.log('filee typee', e.target.type)
     const { name, value } = e.target;
   
    
     if(fieldKey==="district"){
          fetchAllDistrictTaluka(token , value , '' , key);
          setFormData({ ...formData, [e.target.name]: districtOptions.find(opt=>opt.value===value)?.label });
        }else{
          setFormData({ ...formData, [e.target.name]: value });
        }
  };

  const keyMappingDocs = {
    experienceDetail: "experienceDoc",
    govSemiGovExpDetail: "workPerformanceDoc",
    marketPublicConstructionDetail: "constructionDocs" 
  }
   const fetchAllDistrictTaluka = async (token: string , district?:string , taluka?:string , toUpdateDistOpt?:string): Promise<Option[]> => {
     
        try {
          
          let dist;
          let tal;
          if(district || taluka)
          {
            
            dist = district;
            tal = taluka;
          }
        
    
    
           
    
          const response = await getAllAPMC(token , dist , tal);
     
    
       if (dist && !tal) {
            // Step 2: Load Talukas
            
            const talukas = response.data.map((t) => ({
              label: t.Taluka,
              value: t.Taluka,
            }));
    
    
    
           
    
            if(toUpdateDistOpt == "perAddress")
              setTalukaOptionsPer(talukas)
    
            if(toUpdateDistOpt == "regOffAddress")
              setTalukaOptionsReg(talukas)
    
    
       
        
    
          } 
    
        } catch (error) {
          //.error('Error fetching APMC data:', error);
          return [];
        }
      };
  const fetchDistrict =async()=>{
    try {
      const response = await getAllAPMC(token , '' , '');
   

      const districts = response.data.map((d) => ({
        label: d.District,
        value: d.district_id,
      }));

      setDistrictOptions(districts);

    } catch (error) {
      toast.error('Internal Server Error')
    }
  }
    useEffect(()=>{
        fetchDistrict();
    },[])
   const handleSpecialization = (key:string , e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
      const { name, value } = e.target;
     
    
    
     
  if (name === "specialization") {
    setSpecialization((prev: { standard: string; specialization: string }[]) => {
      const existingIndex = prev.findIndex((item) => item.standard === key);

      if (existingIndex !== -1) {
        // Update existing specialization
        const updated = [...prev];
        updated[existingIndex].specialization = value;
        return updated;
      } else {
        // Add new specialization
        return [...prev, { standard: key, specialization: value }];
      }
    });

    setErrors((prev) => ({ ...prev, specialization: "" }));
  }
     
   
    };

  
  const handleExperienceFileChange = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    if (!e.target.files?.length) return;
  
    const fileInput = e.target; // Reference to the input field
    const file = fileInput.files[0];
  
    // File validation
    const allowedFormats = ["application/pdf", "image/jpeg", "image/jpg"];
    const minSize = 40 * 1024; // 40KB
    const maxSize = 3 * 1024 * 1024; // 3MB
  
    if (!allowedFormats.includes(file.type)) {
      toast.error("Only PDF, JPG, and JPEG files are allowed");
      fileInput.value = ""; // Clear the selected file
      return;
    }
  
    if (file.size < minSize || file.size > maxSize) {
      toast.error("File size must be between 40KB and 3MB");
      fileInput.value = ""; // Clear the selected file
      return;
    }
  
    // If validation passes, upload the file
    handleUpload(file, key);
  };
  

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>, field: string) => {
    if (!e.target.files?.length) return;
  
    const fileInput = e.target; // Reference to the input field
    const selectedFile = fileInput.files[0];
  
    const allowedFormats = ["application/pdf", "image/jpeg", "image/jpg"];
    const minSize = 40 * 1024; // 40KB
    const maxSize = 3 * 1024 * 1024; // 3MB
  
    if (!allowedFormats.includes(selectedFile.type)) {
      toast.error("Only PDF, JPG, and JPEG files are allowed");
      fileInput.value = ""; // Clear the selected file
      return;
    }
  
    if (selectedFile.size < minSize || selectedFile.size > maxSize) {
      toast.error("File size must be between 40KB and 3MB");
      fileInput.value = ""; // Clear the selected file
      return;
    }
  
    const fieldNameMap: { [key: string]: string } = {
      itReturnDetail: "itReturns",
      declarationDetail: "declaration",
    };
  
    const mappedField = fieldNameMap[field] || field;
  

  
    // Upload the file
    handleUpload(selectedFile, mappedField);
  
    // Clear validation error for the field
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };
  
  

  const fileValidationSchema = Yup.object().shape({
    file: Yup.mixed<File>()
      .required("File is required")
      .test("fileType", "Only PDF, JPG, and JPEG files are allowed", (value) => {
        if (!value) return false;
        const file = value as File; // Cast value to File
        const allowedFormats = ["application/pdf", "image/jpeg", "image/jpg"];
        return allowedFormats.includes(file.type);
      })
      .test("fileSize", "File size must be between 40KB and 3MB", (value) => {
        if (!value) return false;
        const file = value as File; // Cast value to File
        return file.size >= 40 * 1024 && file.size <= 3 * 1024 * 1024;
      }),
  });

    const handleUpload = async (file:any , fieldName: string) => {



    const existingDoc = docs?.find((doc: any) => doc.documentName === fieldName)
    const docId = existingDoc?.docId?existingDoc?.docId:null;
    

      const formData = new FormData();
      formData.append("file", file as Blob);
      formData.append("documentName", `${fieldName}`);
      formData.append("applicationId", applicationId);
  
      try {
        // setUploading((prev) => ({ ...prev, [fieldName]: true }));
        const res = await submitEnclosureFiles(formData, token , docId);
        //.log("File uploaded successfully", res);

        if(res.success == true)
        {
          if( ["experienceDoc_1", "experienceDoc_2", "experienceDoc_3", 
            "workPerformanceDoc_1", "workPerformanceDoc_2", "workPerformanceDoc_3", 
            "constructionDocs_1", "constructionDocs_2", "constructionDocs_3"].includes(res.data.documentName))
            {
              const expData={
                docId:res.data.id,
                documentName:res.data.documentName,
                fileName:res.data.fileName
              }
              setExperienceDetail((prev) => {
                const existingIndex = prev.findIndex(doc => doc.documentName === res.data.documentName);
                
                if (existingIndex !== -1) {
                  // Update existing document
                  const updatedExperienceDetail = [...prev];
                  updatedExperienceDetail[existingIndex] = expData;
                  return updatedExperienceDetail;
                } else {
                  // Append new document
                  return [...prev, expData];
                }
              });
            }
            
            else{
              const uploadedData={
                docId:res.data.id,
                documentName:res.data.documentName,
                fileName:res.data.fileName
              }
              const documentNameMapping: { [key: string]: string } = {
                itReturnDetail: "itReturns",
                declarationDetail: "declaration",
              };
              
              // Update only the documentName field while keeping the original key
              if (documentNameMapping[res.data.documentName]) {
                uploadedData.documentName = documentNameMapping[res.data.documentName];
              }
         
              setUploadedDoc((prevDocs) => {
                const existingIndex = prevDocs.findIndex((doc) => doc.documentName === uploadedData.documentName);
                if (existingIndex !== -1) {
                  const updatedDocs = [...prevDocs];
                  updatedDocs[existingIndex] = uploadedData;
                  return updatedDocs;
                } else {
                  return [...prevDocs, uploadedData];
                }
              });
             
            }
         toast.success("Document Upoaded successfully");
        }
        else
        toast.error(`${res.message}`)
    
        //.log("Updated uploadedDoc:", uploadedDoc);

      } catch (error) {
        toast.error("File upload failed");
      } 
    };

    const convertFormData = (data: Record<string, any>) => {
    
      const result: Record<string, any> = {};
    
      for (const key in data) {
        // Address fields handling
        if (key.includes('perAddress-') || key.includes('currAddress-') || key.includes('regOffAddress-')) {
          const [prefix, nestedKey] = key.split('-');
    
          if (!result[prefix]) {
            result[prefix] = {};
          }
    
          result[prefix][nestedKey] = data[key];
    
        // Experience & Project Detail Fields
        } else if (key.includes('workPerformanceDoc_') || key.includes('constructionDocs_') || key.includes('experienceDoc_')) {
          const [prefix, field] = key.split('-'); // e.g., "workPerformanceDoc_1-startDate" → ["workPerformanceDoc__1", "startDate"]
          
          //.log('preeefixx', prefix)
          //.log('fielddd', field)

          if (!result[prefix]) {
            result[prefix] = {}; // Use an object instead of an array
        }
        
        if (!result[prefix][field]) {
            result[prefix][field] = {};
        }
        
        result[prefix][field] = data[key];
    
        } else {
          result[key] = data[key]; // Other fields remain unchanged
        }
      }
    
      return result;
    };

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const numericRegex = /^\d+(\.\d+)?$/; // Allows numbers like 3, 3.4
    const mobileRegex = /^[6789]\d{9}$/;
    const minAge = 18;
    const today = new Date();
    const minDate = new Date(today.getFullYear() - minAge, today.getMonth(), today.getDate());

    const validateForm = () => {
      let errors: { [key: string]: string } = {};
      const specialCharRegex = /[^a-zA-Z0-9 ]/; // Only allows letters, numbers, and spaces
      const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format
    
      // Convert rejectedFields into an array of keys
      
      const rejectedFieldsArray = Array.isArray(rejectedFields) ? rejectedFields : Object.keys(rejectedFields);
    
    
      // Validate only fields present in rejectedFields
      Object.keys(rejectedFields).forEach((key) => {
        let value = rejectedFields[key];
        
    
        if (
          [
            "experienceDoc_1",
            "experienceDoc_2",
            "experienceDoc_3",
            "workPerformanceDoc_1",
            "workPerformanceDoc_2",
            "workPerformanceDoc_3",
            "constructionDocs_1",
            "constructionDocs_2",
            "constructionDocs_3",
          ].includes(key)
        ) {
          value = Array.isArray(value) ? value : [value];
    
          value.forEach((item, index) => {
            const projectName = formData[`${key}-projectName`]?.trim();
            const projectAwardedby = formData[`${key}-projectAwardedby`]?.trim();
            const startDateStr = formData[`${key}-startDate`]; // Get value as string
            const endDateStr = formData[`${key}-endDate`]; // Get value as string
        
            const today = new Date();
            const minYearsDifference = 4;
        
            // Convert string dates to Date objects
            const startDate = startDateStr ? new Date(startDateStr) : null;
            const endDate = endDateStr ? new Date(endDateStr) : null;
           
            if (!projectAwardedby) {
              errors[`${key}-projectAwardedby`] = "Project Awarded By is required.";
            } else if (specialCharRegex.test(projectAwardedby)) {
              errors[`${key}-projectAwardedby`] = "No special characters allowed.";
            } else if (projectAwardedby.length > 50) {
              errors[`${key}-projectAwardedby`] = "Maximum length is 50 characters.";
            }
    
            if (!projectName) {
              errors[`${key}-projectName`] = "Project Name is required.";
            } else if (specialCharRegex.test(projectName)) {
              errors[`${key}-projectName`] = "No special characters allowed.";
            }
    
            if (!startDateStr) {
              errors[`${key}-startDate`] = "Start Date is required.";
          } else if (startDate && startDate > today) {
              errors[`${key}-startDate`] = "Start Date cannot be in the future.";
          }
      
          if (!endDateStr) {
              errors[`${key}-endDate`] = "End Date is required.";
          } else if (endDate && endDate > today) {
              errors[`${key}-endDate`] = "End Date cannot be in the future.";
          }
      
            
    
          if (startDate && endDate) {
            const diffInYears = (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24 * 365.25); // Convert milliseconds to years
    
            if (startDate > endDate) {
                errors[`${key}-startDate`] = "Start Date cannot be after End Date.";
                errors[`${key}-endDate`] = "End Date cannot be before Start Date.";
            } 
            // else if (diffInYears < minYearsDifference) {
            //     errors[`${key}-endDate`] = `End Date must be at least ${minYearsDifference} years after Start Date.`;
            // }
        }

            // if (!formData[`${key}-evidenceProof`]) {
            //   errors[`${key}-evidenceProof`] = "File is required.";
            // }

          });
        } else if(["structureErrDoc","otherDoc"].includes(key))
        {
          const structDocUploaded = uploadedDoc.find(doc => doc.documentName === key);
         


          if (!structDocUploaded) {
            errors[key] = "File is required.";
          } 
        }
         else if(["itReturns_1", "itReturns_2", "itReturns_3"].includes(key))
        {
          const itReturnUploaded = uploadedDoc.find(doc => doc.documentName === key);

          if (!itReturnUploaded) {
            errors[key] = "File is required.";
          } 
        }
         else if (typeof value === "object" && value !== null) {
          
          
          // Define excluded keys
          const excludedKeys = [
              "highSchool", "diploma", "bachelorDegree", 
              "mastersDegree", "phd", "itReturnDetail", "declarationDetail"
          ];
      
          // Skip if the key is in excludedKeys
          if (excludedKeys.includes(key)) return;
      
          Object.keys(value).forEach((nestedKey) => {
              if (!rejectedFieldsArray.includes(`${key}`)) return;
      
              if (
                  !formData[`${key}-${nestedKey}`] || 
                  (typeof formData[`${key}-${nestedKey}`] === "string" && formData[`${key}-${nestedKey}`].trim() === "")
              ) {
                  errors[`${key}-${nestedKey}`] = `${nestedKey} is required.`;
              } 
              // else if (specialCharRegex.test(formData[`${key}-${nestedKey}`]) && key !== "dob") {
              //     errors[`${key}-${nestedKey}`] = "No special characters allowed.";
              // }
          });
      }
      else {
          if (!formData[key]?.trim()) {
            errors[key] = "This field is required.";
          } else if (key === "yrOfExpAsBusErr") {
            
              if (!numericRegex.test(formData[key])) {
                errors[key] = "Only numeric values allowed.";
              } else if (parseFloat(formData[key]) < minexp) {
                errors[key] = `Minimum ${minexp} years of experience required.`;
              }
          } else if (key === "regEmailId" && !emailRegex.test(formData[key])) {
            errors[key] = "Enter a valid email address.";
          } else if (key === "mobileNo" && !mobileRegex.test(formData[key])) {
            errors[key] = "Mobile No. is not valid number.";
          }
          else if (key === "dob") {
            const enteredDate = new Date(formData[key]);
          
            if (isNaN(enteredDate.getTime())) {
              errors[key] = "Invalid date format.";
            } else if (enteredDate > minDate) {
              errors[key] = `You must be at least ${minAge} years old.`;
            }
          }
          // else if (specialCharRegex.test(formData[key]) && key !== "dob" && key !== "regEmailId") {
          //   errors[key] = "No special characters allowed.";
          // }
        }
      });
    
      setValidationErrors(errors);
    
      return Object.keys(errors).length === 0; // Returns true if no errors
    };
  
    useEffect(()=>{
      if(Object.keys(validationErrors).length > 0){
        setHasFormError(true);
      }

      if(Object.keys(fileValidationErrors).length > 0){
        setHasFileError(true);
      }

    },[validationErrors , fileValidationErrors])

        const toastCooldown = useRef(false);
    

       const showErrorToast = (message: string) => {
          if (toastCooldown.current) return; // Skip if still in cooldown
        
          toast.error(message );
          toastCooldown.current = true;
        
          // Reset cooldown after 3 seconds
          setTimeout(() => {
            toastCooldown.current = false;
          }, 3000);
        };
    
        const showSuccessToast = (message: string) => {
          if (toastCooldown.current) return; // Skip if still in cooldown
        
          toast.success(message);
          toastCooldown.current = true;
        
          // Reset cooldown after 3 seconds
          setTimeout(() => {
            toastCooldown.current = false;
          }, 3000);
        };
  const getDocumentIndex = (documentName: string): string | null => {
  const match = documentName.match(/\d+$/);
  return match ? match[0] : null;
};


  const handleSubmit = async (status: string, appStatusLevel: string) => {

    
    const result = convertFormData(formData);
    
    let updatedFormData = { ...result };
  

  
    // Ensure uploadedDoc is an array and has data
    const specEligibleKeys = [ "diploma", "bachelorDegree", "mastersDegree", "phd"];

    if (uploadedDoc.length > 0) {
      uploadedDoc.forEach((doc) => {
        if (specEligibleKeys.includes(doc.documentName)) {
          const matchingSpec = specialization.find(item => item.standard === doc.documentName);
          updatedFormData[doc.documentName] = {
            ...doc,
            ...(matchingSpec ? { specialization: matchingSpec.specialization } : {})
          };
        } else {
          updatedFormData[doc.documentName] = doc;
        }
      });
    }
  
  
    // Merge experienceDetail
    
    experienceDetail.forEach((exp) => {
      const { documentName, docId, fileName } = exp;
  
      if (!updatedFormData[documentName]) {
        updatedFormData[documentName] = {};
      }
  
      updatedFormData[documentName] = {
        ...updatedFormData[documentName],
        eveidenceProof: { docId, fileName, documentName },
        index:Number(getDocumentIndex(documentName))
      };
    });
  
    const isValid = await validateForm();


    const itreturn = keyMapping


    const experienceDocKeys = [
      "experienceDoc_1", "experienceDoc_2", "experienceDoc_3",
      "workPerformanceDoc_1", "workPerformanceDoc_2", "workPerformanceDoc_3",
      "constructionDocs_1", "constructionDocs_2", "constructionDocs_3"
    ];

    const itReturnKeys = ["itReturn_1", "itReturn_2", "itReturn_3"];

    const educationDocKeys = [
      "highSchool", "diploma", "bachelorDegree", "mastersDegree", "phd",
    ];

   
   
    // let newErrors = { ...validationErrors }; // Clone existing errors
    let hasError = false;
    let hasEduError = false;

 
    let newErrors: { [key: string]: string } = { };
   
    let newkey;
    experienceDocKeys.forEach((key) => {
      if (key == "itReturnDetail" || key == "declarationDetail" )   {
        newkey = keyMapping[key]; // Map to the correct field name  
      } else {
        newkey = key;
      }
    
      const hasKey = Object.keys(updatedFormData).includes(newkey);
      const hasEvidenceProof = updatedFormData[newkey]?.eveidenceProof !== undefined;
    
   
      if (rejectedFieldsArray.includes(key)) {
        if (!hasKey || !hasEvidenceProof) {
          newErrors[key] = `file is required.`;
          hasError = true;
        }
      }
    });
    

    educationDocKeys.forEach((key) => {
     
      const hasKey = Object.keys(updatedFormData).includes(key);
    
    
    
      if (rejectedFieldsArray.includes(key)) {
        if (!hasKey) {
          newErrors[key] = `file is required.`;
          hasEduError = true;
        }
      }

      if (rejectedFieldsArray.includes(key)) {
        const selectedSpecialization = specialization.find((item) => item.standard === key)?.specialization;
  if(key!="highSchool")
  {      if (!selectedSpecialization || selectedSpecialization.trim() === "") {
          newErrors[`specialization-${key}`] = "Specialization is required.";
          hasEduError = true;
        }}
      }

    });

 
    
    if (!isValid || hasError || hasEduError) {
     
      setFileValidationErrors(newErrors);
      return;
    }
   
  
    if (!status || !appStatusLevel || !applicationId) {
      toast.error("Status, appStatusLevel, or applicationId not found");
      return;
    }
   
    if(comment=='')
    {
      toast.error('Comment is required')
      return;
    }
       if(comment.trim().split(/\s+/).length < 10) {
          toast.error("Comment must be at least 10 words");
          
          return;
        }
    try {
      const data = {
        comment: comment,
        status: status,
        appStatusLevel: appStatusLevel,
        applicationId: applicationId,
        reSubmittedDocs: updatedFormData,
        reSubmittedFields: updatedFormData,
        rejectedDocName: [],
        rejectedFieldName: []
      };
     
       setIsLoading(true);
      const submitData = await submitPanelApproveRejectApplication(data, token);
      setIsLoading(false);
      
      if (submitData.success==true) {
        showSuccessToast("Form re-submitted successfully!");
        navigate('/myApplicationPanel');
      } else {
        toast.error("Submission failed, please try again.");
      }
    } catch (error) {
 
      setIsLoading(false);

      toast.error("An error occurred while submitting the form.");
    }
  };
 

  
  useEffect(()=>{
  
  const trans = applicationTransaction.filter(data=>data.appStatusLevel == "pendingAtPanelResubmission" || data.appStatusLevel == "pendingAtPanelHOResubmission")
  
   const latestComment = trans.reduce((acc , curr)=>{
      return curr.createdAt > acc.createdAt ? curr: acc
  }).comment;

  const arrOfComment =  latestComment.split(',').map(pair => {
    const [key, ...rest] = pair.split(':');
    return {
      key: key.trim(),
      value: rest.join(':').trim()
    };
  });


  setReviews(arrOfComment)
  },[])

  return (
    <div className="tab-content custom-accordion-items">
      <div className="tab-pane active show" id="bottom-justified-tab1" role="tabpanel">
        <div className="accordion accordions-items-separate" id="accordionExample">
          <div className="accordion-item">
            <div className="accordion-header" id="headingOne">
              <div className="accordion-button">
                <div className="d-flex align-items-center flex-fill">
                  <h5 className="text-danger ">{formLanguage.reu_info}({language.reu_info})</h5>
                  <Link
                    to="#"
                    className="d-flex align-items-center collapsed collapse-arrow ms-auto"
                    data-bs-toggle="collapse"
                    data-bs-target="#primaryBorderOne"
                    aria-expanded="false"
                    aria-controls="primaryBorderOne"
                  >
                    <i className="ti ti-chevron-down fs-18" />
                  </Link>
                </div>
              </div>
            </div>
            <div
              id="primaryBorderOne"
              className="accordion-collapse collapse show border-top"
              aria-labelledby="headingOne"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body mt-2">
                <div >
                <div className="row">
      

        {/* Right Column: Input Fields */}
        <div className="col-md-6 border border-e-2">
          <h5 className="mb-3 text-danger p-2 border border-bottom-2">{language.re_info}{"*"}</h5>
       {Object.keys(rejectedFields).map((key) => {




  let value = rejectedFields[key];

  // Convert object to an array if it's one of the expected document types
  if (
    ["experienceDoc_1", "experienceDoc_2", "experienceDoc_3", 
     "workPerformanceDoc_1", "workPerformanceDoc_2", "workPerformanceDoc_3", 
     "constructionDocs_1", "constructionDocs_2", "constructionDocs_3"].includes(key)
  ) {
    value = Array.isArray(value) ? value : [value]; // Convert object to array if needed

    return value.map((item, index) => (
      <div key={`${key}-${index}`} className="border p-3 mb-3">
        <h5 className="mb-4">{ language[fieldsOptions.find((doc) => doc.value === key)?.value] || language[key]} <span className="text-danger">*</span> </h5>


        {/* Project Name */}
        <div className="mb-3">
          <label className="form-label">{formLanguage.project_name} ({language.project_name})<span className="text-danger">*</span></label>
          <input
            type="text"
              className={`form-control ${validationErrors[`${key}-projectName`] ? "is-invalid" : ""}`}
            name={`${key}-projectName`}
            value={formData[`${key}-projectName`] || ""}
            onChange={handleInputChange}
          />
            {validationErrors[`${key}-projectName`] && (
              <div className="invalid-feedback">{validationErrors[`${key}-projectName`]}</div>
            )}
        </div>

        {/* Evidence Proof (File Upload) */}
        <div className="mb-3">
          <label className="form-label">{formLanguage.attested_copy} ({language.attested_copy})<span className="text-danger">*</span></label>
          {/* {item?.eveidenceProof?.fileName && (
            <div className="mb-2">
              <small>Current File: {item.eveidenceProof.fileName}</small>
            </div>
          )} */}
          <input
            type="file"
            className={`form-control ${fileValidationErrors[`${key}`] ? "is-invalid" : ""}`}
            name={`${key}`}
            onChange={(e) => handleExperienceFileChange(e, key)}
          />
             {fileValidationErrors[key] && fileValidationErrors[key].trim() !== "" && (
              <div className="invalid-feedback">
                {fileValidationErrors[key]}
              </div>
            )}
        </div>

        {/* Start Date */}
        <div className="mb-3">
          <label className="form-label">{formLanguage.start_date} ({language.start_date})<span className="text-danger">*</span></label>
          <input
            type="date"
            className={`form-control ${validationErrors[`${key}-startDate`] ? "is-invalid" : ""}`}
            name={`${key}-startDate`}
            value={formData[`${key}-startDate`] || ""}
            onChange={handleInputChange}
            max={new Date().toISOString().split("T")[0]} 
          />
            {validationErrors[`${key}-startDate`] && (
              <div className="invalid-feedback">{validationErrors[`${key}-startDate`]}</div>
            )}
        </div>

        {/* End Date */}
        <div className="mb-3">
          <label className="form-label">{formLanguage.end_date} ({language.end_date} )<span className="text-danger">*</span></label>
          <input
            type="date"
            className={`form-control ${validationErrors[`${key}-endDate`] ? "is-invalid" : ""}`}
            min={formData[`${key}-startDate`]}
            max={new Date().toISOString().split("T")[0]} 
            name={`${key}-endDate`}
            value={formData[`${key}-endDate`] || ""}
            onChange={handleInputChange}
          />
           {validationErrors[`${key}-endDate`] && (
              <div className="invalid-feedback">{validationErrors[`${key}-endDate`]}</div>
            )}
        </div>

        <div className="mb-3">
          <label className="form-label">{formLanguage.projectAwardedby} ({language.projectAwardedby} )<span className="text-danger">*</span></label>
          <input
            type="text"
            className={`form-control ${validationErrors[`${key}-projectAwardedby`] ? "is-invalid" : ""}`}
            name={`${key}-projectAwardedby`}
            value={formData[`${key}-projectAwardedby`] || ""}
            onChange={handleInputChange}
          />
           {validationErrors[`${key}-projectAwardedby`] && (
              <div className="invalid-feedback">{validationErrors[`${key}-projectAwardedby`]}</div>
            )}
        </div>

      </div>
    ));
  } 

  else if (typeof value === "object" && value !== null) {
    if (["itReturns_1", "itReturns_2","itReturns_3", "declarationDetail" , "structureErrDoc","otherDoc"].includes(key)) {

      const labelKey = fieldsOptions.find((doc) => doc.value == key)?.value;
     
      return (
        <div key={key} className="mb-3">
          <label className="form-label">{`${formLanguage[key]}`} ({language[key]})<span className="text-danger">*</span></label>
          <p className="text-danger mb-1">{language.file_type}</p>
          <div className="input-group">
            <input
              type="file"
              accept=".pdf, .jpeg, .jpg"
              name={key}
              className={`form-control ${fileValidationErrors[key]  ? "is-invalid" : ""}`}
              onChange={(event) => handleFileChange(event, key)}
            />
          </div>
          {fileValidationErrors[key]  && 
              <div className="text-danger">
                {fileValidationErrors[key] }
              </div>
            }

            {validationErrors[key] && (
            <div className="text-danger">{validationErrors[key]}</div>
          )}
        </div>
      );
    }
    else if([ "highSchool", "diploma", "bachelorDegree", "mastersDegree", "phd"].includes(key)){
      const labelKey = fieldsOptions.find((doc) => doc.value == key)?.value;
      return (
        <>
        <div key={key} className="mb-3">
            <label className="form-label">{`${formLanguage[labelKey]}`} ({language[key]})<span className="text-danger">*</span></label>
            <p className="text-danger mb-1">{language.file_type}</p>
          <div className="input-group">
            <input
              type="file"
              accept=".pdf, .jpeg, .jpg"
              name={key}
              className={`form-control ${fileValidationErrors[key]  ? "is-invalid" : ""}`}
              onChange={(event) => handleFileChange(event, key)}
            />
          </div>
          {fileValidationErrors[key]  && 
              <div className="text-danger">
                {fileValidationErrors[key] }
              </div>
            }
        </div>

          {[ "diploma", "bachelorDegree", "mastersDegree", "phd"].includes(key) && <div key={key} className="mb-3">
          <label className="form-label">વિશેષતા (Specialization)<span className="text-danger">*</span></label>
          <div className="input-group">
          <select
                      className="form-control"
                      name="specialization"
                      value={
                        specialization.find((item) => item.standard === key)?.specialization || ""
                      }
                      onChange={(e) => handleSpecialization(key, e)}
                    >
                      <option value="" disabled>-- Select Specialization --</option>
                      <option value="civilEngineer">સિવિલ એન્જિનિયર (Civil Engineer)</option>
                      <option value="architect">આર્કિટેક્ટ (Architect)</option>
                      <option value="constructionEngineer">બાંધકામ ઈજનેર (Construction Engineer)</option>
                      <option value="billingServiceEngineer">બિલ્ડિંગ સર્વિસ એન્જિનિયર (Building Service Engineer)</option>
                      <option value="other">અન્ય (Other)</option>
                    </select>
          </div>
         {fileValidationErrors[`specialization-${key}`] && (
      <div className="text-danger">
        {fileValidationErrors[`specialization-${key}`]}
      </div>
    )}
          </div>}
        </>

      );
    }
    else if(!["structureErrDoc"].includes(key)) {
      return Object.keys(value).map((nestedKey) => (
        
        <div key={`${key}-${nestedKey}`} className="mb-3">
          <label className="form-label">
            {`${formLanguage[fieldsOptions.find((doc) => doc.value === key)?.value || key]} - ${formLanguage[nestedKey]}  
            (${language[fieldsOptions.find((doc) => doc.value === key)?.value || key]} - (${language[nestedKey]}))`}
            <span className="text-danger">*</span>
          </label>
                                             { nestedKey === "district" ? (
                                        <CommonSelect
                                          options={[...districtOptions].sort((a, b) => a.label.localeCompare(b.label))}
                                          value={districtOptions.find(opt => opt.value ===  formData[`${key}-${nestedKey}`]) || null}
                                          onChange={option => handleInputChange({
                                            target: {
                                              name: `${key}-${nestedKey}`,
                                              value: option ? option.value : ""
                                            }
                                          },nestedKey,key)}
                                        />
                                      ) :
                                       nestedKey === "taluka" ? (
  (() => {
    let options = [];

    if (key === "perAddress") {
      options = talukaOptionsPer;
    } else if (key === "regOffAddress") {
      options = talukaOptionsReg;
    }

    return (
      <CommonSelect
        options={[...options].sort((a, b) => a.label.localeCompare(b.label))}
        value={
          options.find(
            (opt) => opt.value === formData[`${key}-${nestedKey}`]
          ) || null
        }
        onChange={(option) =>
          handleInputChange({
            target: {
              name: `${key}-${nestedKey}`,
              value: option ? option.value : "",
            },
          },nestedKey,key)
        }
        // onChange={(option) =>
        //   handleObjectChange({
        //     target: {
        //       name: `${key}-${index}-${fieldKey}`,
        //       value: option ? option.value : "",
        //     },
        //   })
        // }
      />
    );
  })()
)  : (  <input
            type="text"
            className={`form-control ${validationErrors[`${key}-${nestedKey}`] ? "is-invalid" : ""}`}
            name={`${key}-${nestedKey}`}
            value={formData[`${key}-${nestedKey}`] || ""}
            onChange={handleInputChange}
          />)}
          {validationErrors[`${key}-${nestedKey}`] && (
            <div className="text-danger">{validationErrors[`${key}-${nestedKey}`]}</div>
          )}
        </div>
        
      ));
      
    }
  }
  // Handle simple key-value pairs
  else {
   
    return (
      <div key={key} className="mb-3">
        {(() => {
          const labelKey = fieldsOptions.find((doc) => doc.value === key)?.value;
     
          return (
            <h5>
              {`${formLanguage[labelKey]} (${language[labelKey]})`}<span className="text-danger">*</span>
            </h5>
          );
        })()}
        
        <input
          type={key === "dob" ? "date" : "text"}
          className={`form-control ${validationErrors[key] ? "is-invalid" : ""}`}
          name={key}
          value={formData[key] || ""}
          onChange={handleInputChange}
          {...(key === "dob" ? { max: new Date().toISOString().split("T")[0] } : {})}
        />
        
        {validationErrors[key] && <div className="invalid-feedback">{validationErrors[key]}</div>}
      </div>
    );
  }
})}

        </div>
        <div className="col-md-6 border border-start-2">
        <h4 className="mb-3 border border-bottom-2 p-2">Review By Department</h4>
          <ul className="list-group">
            {reviews.map((item, index) => (
              <li key={index} className="list-group-item">
                <strong>{language[item.key] || item.key}:</strong> {item.value}
              </li>
            ))}
          </ul>
        </div>
      </div>

                  {  buttonData.length > 0  && 
                  <div className="row">
                    <textarea
                    className="form-control mb-3"
                    placeholder="Enter your comment (min 10 words)"
                    name="currAt"
                    value={comment!=""? comment : ""} // Bind value to state
                    onChange={(e) => setComment(e.target.value)} // Update state on type
                    rows={4} // Adjust number of rows as needed
               
                  />

                      <div className="d-flex gap-2">
                        {buttonData.map((button) => (
                          <button
                            key={button.status}
                            className="btn btn-success h-10 w-70"
                            onClick={() => handleSubmit(button.status , button.appStatusLevel)}
                            disabled={isLoading}
                          >
                            {isLoading ? (
                              <i className="ion-load-a ion-spin"></i> // Loading spinner
                            ) : (
                              `${button.buttonLabel}` // Add button text
                            )}
                          </button>
                        ))}
                        <ToastContainer position="top-right" autoClose={3000} />
                        
                      </div>

                  </div>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RectificationOnResjection;
